module.exports = __webpack_public_path__ + "img/app-lld.b62e383c.webp";